import { render } from "./ProjectDetail.vue?vue&type=template&id=d87bde6a&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=d87bde6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d87bde6a"

export default script